import { createQuoteDepositPayLogic } from './createQuoteDepositPayLogic';

export const logic = [createQuoteDepositPayLogic];
